import { useTranslation } from "react-i18next";
import { useNavigate, useLocation } from "react-router-dom";
import { Button } from "react-bootstrap";
import { useEffect } from "react";
import { jsPDF } from "jspdf";

import EmailConfirmationMessage from "./EmailConfirmationMessage";

import Loader from "./Loader";

/**
 * We need this messages:
 * - Return could not be posted into ExitB: "Your return could not be registered ....."
 * - Sth. went wrong with Label (could not be sent/generated)
 *
 */

const Confirmation = ({ ups, dhl, dhlToUps, emailSent, email, labelSupport, supportError, isLoading, terminate, commentPosted, dhlLabelImageUrl }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { state } = useLocation();

  if (emailSent && commentPosted) {
    sessionStorage.setItem("completed", true);
  }

  if (ups) {
    sessionStorage.setItem("ups", JSON.stringify(ups));
  }

  useEffect(() => {
    if (state === null) {
      navigate(1);
    }
  });

  const handleDownloadPdf = async () => {
    if (!dhlLabelImageUrl) return;

    const pdf = new jsPDF();

    // Convert image to Base64 if needed
    const img = new Image();
    img.src = dhlLabelImageUrl;
    img.onload = () => {
      const imgWidth = 180; // scale for A4 width (210mm)
      const imgHeight = (img.height * imgWidth) / img.width;

      pdf.addImage(img, "PNG", 15, 15, imgWidth, imgHeight);
      pdf.save("dhl-return-label.pdf");
    };
  };

  return (
    <div className="confirmation-container">
      {isLoading && <Loader />}
      {!labelSupport && !isLoading && emailSent && commentPosted && <EmailConfirmationMessage ups={ups} dhl={dhl} dhlToUps={dhlToUps} email={email} />}

      {/* logic to render dhl return label */}
      {!labelSupport && !isLoading && emailSent && commentPosted && dhlLabelImageUrl && (
        <div className="my-4">
          <h5>{t("confirmationView.downloadUpsLabel.heading")}</h5>
          <img
            src={dhlLabelImageUrl}
            alt="DHL Return Label"
            style={{ maxWidth: "300px", border: "1px solid #ccc", marginBottom: "1rem" }}
          />
          <br />
          <a
            href={dhlLabelImageUrl}
            download="dhl-return-label.png"
            className="btn btn-secondary me-2"
          >
            {t("buttons.downloadUpsLabel")}
          </a>

          <Button
            onClick={handleDownloadPdf}
            className="btn btn-secondary"
          >
            {t("buttons.downloadUpsLabelPdf")}
          </Button>

        </div>
      )}
      {/* end : logic to render dhl return label */}

      {supportError && !isLoading && !sessionStorage.getItem("completed") && (
        <div className="my-4">
          {t("confirmationView.labelError.text1")}&nbsp;
          <a href="mailto:info@gusti-leder.de">info@gusti-leder.de</a>&nbsp;
        </div>
      )}
      {labelSupport && !isLoading && <div className="my-4">{t("confirmationView.support.text")}</div>}
      {!isLoading && (
        <Button className="p-1 btn" variant="dark" onClick={terminate}>
          {t("buttons.terminate")}
        </Button>
      )}
    </div>
  );
};

export default Confirmation;
